import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Redirect } from "react-router";
import { RouteComponentProps } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { NewUser } from "sweet-global";
import { images } from "sweet-assets";
import Button from "sweet-web/components/universal/Button";
import Input from "sweet-web/components/universal/Input";
import PhoneNumberInput from "sweet-web/components/universal/Input/PhoneNumberInput";
import { Form } from "sweet-web/components/universal/View";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import { CreateUser } from "sweet-web/redux/user/actions";

const Header = styled.div`
  width: 100%;
  padding: 15% 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const LightSection = styled.div`
  margin-left: -60px;
  margin-right: -60px;
  padding: 40px 60px 60px 60px;
  background-color: ${colors.nearWhite};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-bottom: 80px;
`;

const InputRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const FormWrapper = styled.div`
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.08) 0 0 4px 0;
  background-color: ${colors.white};
  @media screen and (max-width: 600px) {
    margin-top: 30px;
  }
`;

const Background = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: auto;
  z-index: -1;
  min-height: 800px;
  object-fit: cover;
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const HeaderTitle = styled.h1`
  color: ${colors.white};
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const HeaderSubtitle = styled.p`
  color: ${colors.white};
  font-size: 17px;
  font-weight: 500;
`;

const LightSectionLabel = styled.h4`
  color: ${colors.gray};
  font-size: 14px;
  font-weight: 600;
`;

const Partners = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 80px;
  @media screen and (max-width: 600px) {
    margin-bottom: 40px;
  }
`;

const SectionTitle = styled.h2`
  color: ${colors.nearBlack};
  font-size: 17px;
  font-weight: 600;
`;

const SectionSubtitle = styled.p`
  color: ${colors.gray};
  font-size: 14px;
  font-weight: 500;
`;

const PartnerImage = styled.img`
  height: 80px;
  width: auto;
  margin: 40px 40px 0 40px;
`;

const Percentage = styled.p`
  color: ${colors.primary};
  font-size: 36px;
  font-weight: 600;
`;

const PercentageLabel = styled.p`
  color: ${colors.darkGray};
  font-size: 14px;
  font-weight: 500;
`;

const SectionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-end;
  width: 100%;
  padding-top: 60px;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 40px;
  }
`;

const SectionItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin: 0 20px;
  @media screen and (max-width: 600px) {
    margin: 20px;
  }
`;

const SectionItemImage = styled.img`
  width: 200px;
  height: 150px;
  object-fit: contain;
  margin-bottom: 30px;
  @media screen and (max-width: 600px) {
    margin-bottom: 10px;
  }
`;

const SectionLabel = styled.p`
  color: ${colors.nearBlack};
  font-size: 14px;
  font-weight: 600;
`;

const Testimonial = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    align-items: center;
  }
`;

const TestimonialText = styled.p`
  color: ${colors.darkGray};
  font-size: 17px;
  font-weight: 500;
  max-width: calc(100% - 120px);
  @media screen and (max-width: 600px) {
    max-width: calc(100% - 40px);
    text-align: center;
  }
`;

const TestimonialUser = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  @media screen and (max-width: 600px) {
    align-items: center;
    margin-top: 30px;
  }
`;

const TestimonialUserImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 30px;
  margin-bottom: 5px;
`;

const TestimonialUserName = styled.p`
  color: ${colors.nearBlack};
  font-size: 17px;
  font-weight: 500;
  text-align: right;
  @media screen and (max-width: 600px) {
    text-align: center;
  }
`;

const TestimonialUserLabel = styled.p`
  color: ${colors.gray};
  font-size: 12px;
  font-weight: 500;
  text-align: right;
  @media screen and (max-width: 600px) {
    text-align: center;
  }
`;

type Props = ConnectedProps<typeof connector> & RouteComponentProps;

const initialUser: NewUser = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  emailAddress: "",
  image: "",
  type: "VENUE"
};

const JoinVenue: React.FC<Props> = props => {
  const { loggedIn, loading } = props;

  const [user, setUser] = useState(initialUser);
  const [password, setPassword] = useState("");

  if (loggedIn) {
    return <Redirect to="/listings" />;
  }

  const onSubmit = e => {
    e.preventDefault();
    props.CreateUser(user, password);
  };

  const goToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <React.Fragment>
      <Header>
        <Background src={images.marketing.background} />
        <HeaderText>
          <HeaderTitle>
            Make more events happen,
            <br />
            with less headache.
          </HeaderTitle>
          <HeaderSubtitle>
            Venue marketing, client communication, and bookings - all in one
            place
          </HeaderSubtitle>
        </HeaderText>
        <FormWrapper>
          <Form onSubmit={onSubmit} style={{ padding: 0, width: 300 }}>
            <InputRow>
              <Input
                title={"First Name"}
                value={user.firstName}
                style={{ flex: 1, marginRight: 5 }}
                onChange={value => {
                  setUser(u => ({
                    ...u,
                    firstName: value
                  }));
                }}
              />

              <Input
                title={"Last Name"}
                value={user.lastName}
                style={{ flex: 1, marginLeft: 5 }}
                onChange={value => {
                  setUser(u => ({
                    ...u,
                    lastName: value
                  }));
                }}
              />
            </InputRow>

            <PhoneNumberInput
              value={user.phoneNumber}
              onChange={value => {
                setUser(u => ({
                  ...u,
                  phoneNumber: value
                }));
              }}
            />

            <Input
              title={"Email"}
              value={user.emailAddress}
              onChange={value => {
                setUser(u => ({
                  ...u,
                  emailAddress: value
                }));
              }}
            />

            <Input
              title={"Password"}
              type={"password"}
              value={password}
              onChange={value => {
                setPassword(value);
              }}
            />

            <Button
              submit={true}
              loading={loading}
              title="Start Free Listing"
            />
          </Form>
        </FormWrapper>
      </Header>
      <LightSection>
        <LightSectionLabel>Featured Partners</LightSectionLabel>
        <Partners>
          <PartnerImage src={images.marketing.box63} />
          <PartnerImage src={images.marketing.cask} />
          <PartnerImage src={images.marketing.crown} />
          <PartnerImage src={images.marketing.sherkaan} />
        </Partners>
      </LightSection>
      <Section>
        <SectionTitle>
          Digital marketing for your event space, made easy
        </SectionTitle>
        <SectionSubtitle>
          Showcase and publicize your venue in 5 minutes.
        </SectionSubtitle>
        <SectionRow>
          <SectionItem>
            <SectionItemImage src={images.marketing.spaces} />
            <SectionLabel>Event Spaces and Starting Prices</SectionLabel>
          </SectionItem>
          <SectionItem>
            <SectionItemImage src={images.marketing.options} />
            <SectionLabel>Food {"&"} Drink Options</SectionLabel>
          </SectionItem>
          <SectionItem>
            <SectionItemImage src={images.marketing.photosandmenus} />
            <SectionLabel>Photos and Menus</SectionLabel>
          </SectionItem>
        </SectionRow>
      </Section>
      <LightSection>
        <Percentage>70%</Percentage>
        <PercentageLabel>
          of people prefer to book services online
        </PercentageLabel>
        <Button
          title="Don't miss online sales"
          onClick={goToTop}
          style={{ position: "absolute", bottom: -30, width: "auto" }}
        />
      </LightSection>
      <Section>
        <SectionTitle>Seamlessly manage client commiunication</SectionTitle>
        <SectionSubtitle>
          Sweet powers your event opportunities wherever you go
        </SectionSubtitle>
        <SectionRow>
          <SectionItem>
            <SectionItemImage src={images.marketing.papertrail} />
            <SectionLabel>Consolidated Paper Trail</SectionLabel>
          </SectionItem>
          <SectionItem>
            <SectionItemImage src={images.marketing.chat} />
            <SectionLabel>Integrated Chat</SectionLabel>
          </SectionItem>
          <SectionItem>
            <SectionItemImage src={images.marketing.mobileapp} />
            <SectionLabel>Sweet Mobile App</SectionLabel>
          </SectionItem>
        </SectionRow>
      </Section>
      <Section>
        <SectionTitle>
          Convert inquiries into deposits and bookings
        </SectionTitle>
        <SectionSubtitle>
          Stop wasting time on the phone and start making events happen
        </SectionSubtitle>
        <SectionRow>
          <SectionItem>
            <SectionItemImage src={images.marketing.instantquote} />
            <SectionLabel>Instant Starting Price Estimation</SectionLabel>
          </SectionItem>
          <SectionItem>
            <SectionItemImage src={images.marketing.livebooking} />
            <SectionLabel>Live Booking Trail</SectionLabel>
          </SectionItem>
          <SectionItem>
            <SectionItemImage src={images.marketing.payments} />
            <SectionLabel>Secure, Timely Payments</SectionLabel>
          </SectionItem>
        </SectionRow>
      </Section>
      {/* <LightSection>
        <Testimonial>
          <TestimonialText>
            Thank you so much for sharing your gift of knowledge and for all the
            help you are giving us to compete with this new market. We so
            appreciate it. Adding more revenue to our day, during those slow
            times will help us pay our beloved staff even more, and will give us
            more funds to donate to our community. And, maybe we can even get
            new "toys" for the kitchen:-)
          </TestimonialText>
          <TestimonialUser>
            <TestimonialUserImage src={images.marketing.claire} />
            <TestimonialUserName>Claire</TestimonialUserName>
            <TestimonialUserLabel>Claire's Corner Copia</TestimonialUserLabel>
            <TestimonialUserLabel>New Haven</TestimonialUserLabel>
          </TestimonialUser>
        </Testimonial>
        <Button
          title="Start listing for free"
          onClick={goToTop}
          style={{ position: "absolute", bottom: -30, width: "auto" }}
        />
      </LightSection> */}
    </React.Fragment>
  );
};

const mapState = (state: RootState) => ({
  loggedIn: selectors.loggedIn(state),
  loading: selectors.isAuthenticating(state) || selectors.isCreatingUser(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      CreateUser
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(JoinVenue);
